import { Check, Building2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { type ProfileMe } from '@/lib/api/profile';
// Одна карта меток на весь фронт (ADR-081 §4): своя тут расходилась с «Командой».
import { roleLabel } from '@/pages/team/teamLogic';

/**
 * Раздел «Активная компания» — current tenant + список доступных.
 *
 * Список — read-only витрина: сменить кабинет можно по ссылке внизу
 * (`/auth/select-tenant`) или прямо в шапке, в выпадашке рядом с названием
 * компании. Обе точки ходят в `POST /auth/select-tenant` (AK-660) — до него
 * ручки не существовало вовсе, а ссылка вела в 404.
 */
export function ProfileSectionTenant({ me }: { me: ProfileMe }) {
  if (me.tenants.length === 0) {
    return (
      <Alert>
        <Building2 className="h-4 w-4" />
        <AlertDescription>
          У вас нет доступа к компаниям. Попросите админа выслать приглашение.
        </AlertDescription>
      </Alert>
    );
  }

  const multi = me.tenants.length > 1;

  return (
    <div className="space-y-3">
      <ul className="space-y-1.5">
        {me.tenants.map((t) => (
          <li
            key={t.id}
            className="flex items-center gap-2 px-2 py-1.5 rounded-md bg-secondary/40"
          >
            <Building2 className="h-4 w-4 text-muted-foreground shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-foreground truncate" title={t.name}>
                {t.name}
              </p>
              <p className="text-xs text-muted-foreground">
                {roleLabel(t.role)}
              </p>
            </div>
            {t.is_active && (
              <Badge variant="secondary" className="shrink-0 gap-1">
                <Check className="h-3 w-3" />
                Активна
              </Badge>
            )}
          </li>
        ))}
      </ul>

      {multi && (
        <a
          href="/auth/select-tenant"
          className="text-xs text-primary hover:underline inline-block"
        >
          Сменить активную компанию →
        </a>
      )}
    </div>
  );
}
